/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  boxContainer: Item<'BoxContainer'>;
  box: Item<'Box'>;
  typography: Item<'Typography'>;
  popover: Item<'Popover'>;
  typography1: Item<'Typography'>;
  box1: Item<'Box'>;
} = {
  box: {
    children: ['typography', 'popover'],
    itemId: 'box',
    parent: 'boxContainer',
    props: {
      bgcolor: {
        type: 'text',
        value: 'background.paper',
      },
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      borderRadius: '16px',
      maxWidth: '160px',
      padding: {
        all: 12,
      },
    },
    type: 'Box',
  },
  box1: {
    children: ['typography1'],
    itemId: 'box1',
    parent: 'popover',
    props: {
      maxWidth: '220px',
      padding: {
        all: 16,
      },
    },
    type: 'Box',
  },
  boxContainer: {
    children: ['box'],
    itemId: 'boxContainer',
    parent: 'root',
    props: {
      boxHeight: '100%',
    },
    type: 'BoxContainer',
  },
  popover: {
    children: ['box1'],
    itemId: 'popover',
    parent: 'box',
    props: {
      backgroundColor: 'rgba(74,144,226,1)',
      borderRadius: 2,
      delay: 0,
      open: true,
      popoverHeight: 100,
      popoverWidth: 200,
    },
    type: 'Popover',
  },
  root: {
    children: ['boxContainer'],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'default',
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box',
    props: {
      text: {
        type: 'text',
        value: 'Mouse over to open the Popover',
      },
    },
    type: 'Typography',
  },
  typography1: {
    children: [],
    itemId: 'typography1',
    parent: 'box1',
    props: {
      color: {
        type: 'text',
        value: '#fff',
      },
      text: {
        type: 'text',
        value:
          'You can select this text. This Popover will stay open as long as the cursor remains on this.',
      },
    },
    type: 'Typography',
  },
};

export const helpRenders: ComponentSample<'Popover'>[] = [
  {
    title: 'Popover',
    page,
    exampleId: 'eg1',
    clearParentChildren: false,
    height: 280,
    visibleProps: ['placement'],
    item: {
      itemId: 'popover',
      type: 'Popover',
      children: ['box1'],
      parent: 'box',
      props: {
        popoverWidth: 200,
        popoverHeight: 100,
        delay: 0,
        backgroundColor: 'rgba(74,144,226,1)',
        open: true,
        borderRadius: 2,
      },
    },
  },
];
